'use client';

import { useEffect, useState } from 'react';
import useGameContext from '~/client/components/Game/context/Game/useGameContext';
import Speaker from '@/external/icons/original_games/Speaker';
import SpeakerMuted from '@/external/icons/original_games/SpeakerMuted';

function defaultMute(): boolean {
  return localStorage.getItem('desktopGameMuted') === 'true';
}

const MuteToggle: FC = () => {
  const [isMuted, setIsMuted] = useState(false);
  const { setOptions } = useGameContext();

  useEffect(() => {
    setIsMuted(defaultMute());
  }, []);

  useEffect(() => {
    setOptions((prev) => ({ ...prev, mute: String(isMuted) }));
  }, [isMuted, setOptions]);

  const onToggleChange = () => {
    const next = !isMuted;
    localStorage.setItem('desktopGameMuted', String(next));
    setIsMuted(next);
  };

  return (
    <div
      className="cursor-pointer select-none p-2"
      data-testid="toggle-mute"
      onClick={onToggleChange}
    >
      {isMuted ? (
        <SpeakerMuted className="text-moon-24 text-trunks" />
      ) : (
        <Speaker className="text-moon-24 text-trunks" />
      )}
    </div>
  );
};

export default MuteToggle;
